import React, { useRef, useState } from 'react';

import axios from 'axios';

import ModalPortal from '../modal_portal/modal_portal';
import { useCookies } from 'react-cookie';

import { sendAlimtalkLog } from '../../common/sendLog';

import styles from './promo_popup.module.css';

const moreInfos = [
  {
    title: '영업 상태',
    name: 'state',
    options: [
      { label: '영업중', id: 'open' },
      { label: '오픈예정', id: 'notOpen' },
    ],
  },
  {
    title: '업종 선택',
    name: 'type',
    options: [
      { label: '외식업', id: 'catering' },
      { label: '무인매장', id: 'unmanned' },
      { label: '기타', id: 'etc' },
    ],
  },
];

const regExp = {
  phone: /^(010)[0-9]{3,4}[0-9]{4}$/,
};

const PromoPopup = ({ setPromoOpen }) => {
  const [activeStep, setActiveStep] = useState(1);
  const [phone, setPhone] = useState('');
  const agreeRef = useRef();

  const [moreInfo, setMoreInfo] = useState({
    pageId: '',
    state: '',
    type: '',
  });

  const [loading, setLoading] = useState(false);
  const [alertPopup, setAlertPopup] = useState({
    type: 'success',
    open: false,
  });

  const [cookie, setCookie] = useCookies(['alimtalk']);
  const saveCookie = () => {
    const now = new Date();
    let date = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
    let count = 1;
    const savedCookie = cookie.alimtalk;
    if (savedCookie) {
      count = savedCookie.count + 1;
    }

    setCookie('alimtalk', { phone, date, count });
  };

  const goToDetail = (e) => {
    e.preventDefault();

    window.open(
      'https://www.notion.so/unospay/97e677760fc14ae8a4eaba5e0f01bde1'
    );
  };

  const onInputChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    if (name === 'phoneNum') {
      value = value.replace(/-/gi, '');
      if (!Number.isInteger(value * 1) || value.length > 11) return;
      value = addHyphen(value);
      setPhone(() => value);
    } else {
      setMoreInfo((old) => {
        return { ...old, [name]: value };
      });
    }
    return;
  };

  const sendAlimTalk = async (phone) => {
    const savedCookie = cookie.alimtalk;
    if (savedCookie) {
      let now = new Date();
      let date = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
      if (
        savedCookie &&
        savedCookie.phone === phone &&
        savedCookie.date === date &&
        savedCookie.count >= 3
      ) {
        alert('이미 가격표를 전송했습니다.');
        setLoading(false);
        return;
      }
    }

    /* real */
    const url = '/api/send_price_list.php';
    sendAlimtalkLog();

    /* test */
    //const testURL = 'https://www.unospay.com/api/send_price_list.php';

    const formatedPhone = phone.replace(/-/gi, '');
    await axios
      .post(url, { phone: formatedPhone })
      .then((res) => {
        setLoading(false);
        const data = res.data;
        let success = true;
        if (!data || !data.success || data.result !== '100') {
          success = false;
        } else {
          saveCookie();
          setMoreInfo((info) => ({ ...info, pageId: data.databaseId }));
        }

        setAlertPopup(() => ({
          type: success ? 'success' : 'fail',
          open: true,
        }));
        setActiveStep(2);
        setTimeout(() => {
          setAlertPopup((al) => ({ ...al, open: false }));
        }, 1500);
      })
      .catch((err) => console.log(err));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    if (!activeStep) alert('error');

    if (activeStep === 1) {
      if (!phone) {
        alert('휴대폰 번호는 반드시 입력해주세요');
        setLoading(false);
        return;
      }

      if (!regExp.phone.test(phone.replace(/-/gi, ''))) {
        alert('연락처를 바르게 입력해주세요.');
        setLoading(false);
        return;
      }

      if (!agreeRef.current.checked) {
        alert('개인정보 수집 및 이용에 동의해주셔야 신청이 가능합니다.');
        setLoading(false);
        return;
      }

      sendAlimTalk(phone);
    } else {
      /* 자세한 상담 */
      const { state, type } = moreInfo;

      if (!state || !type) {
        alert('영업 상태와 업종을 선택해 주세요.');
        setLoading(false);
        return;
      }

      sendMoreInfo(moreInfo);
    }
  };

  const sendMoreInfo = async (params) => {
    const url = '/api/send_price_update.php';

    //const testURL = 'https://www.unospay.com/api/send_price_update.php';

    let { state, type, pageId } = params;
    state = state === 'open' ? '매장운영중' : '오픈예정';
    type =
      type === 'catering'
        ? '외식업'
        : type === 'unmanned'
        ? '무인매장'
        : '기타';

    await axios
      .patch(url, { state, type, pageId })
      .then((res) => {
        //console.log(res);
        //const data = res.data;

        setAlertPopup(() => ({ type: 'Update Success', open: true }));

        setTimeout(() => {
          setPromoOpen(false);
          setAlertPopup((al) => ({ ...al, open: false }));
          setLoading(false);
        }, 1500);
      })
      .catch((err) => console.log(err));
  };

  return (
    <ModalPortal>
      <div className={styles.container}>
        {activeStep === 1 && (
          <>
            <div className={styles.titleBox}>
              <h2 className={styles.title}>키오스크 & 포스 가격표 받아보기</h2>
              <p className={styles.description}>
                가격표를 받을 수 있는 휴대폰 번호를 입력해 주세요. <br />
                5분 이내로 가격표가 발송됩니다.
              </p>
            </div>

            <div className={styles.contentBox}>
              <label htmlFor='phone'>
                휴대폰 번호 <span className={styles.require}>*</span>
              </label>
              <input
                name='phoneNum'
                onChange={(e) => onInputChange(e)}
                type='text'
                value={phone}
                placeholder='숫자만 입력해 주세요.'
              />

              <div className={styles.checkBtn}>
                <input
                  className={styles.checkInput}
                  ref={agreeRef}
                  name='agreeInfo'
                  type='checkbox'
                  id='agreeInfo'
                />
                <label htmlFor='agreeInfo'>
                  개인정보 수집 및 이용에 동의합니다.
                  <span className={styles.require}>*</span>
                </label>
                <span className={styles.detailBtn} onClick={goToDetail}>
                  [자세히 보기]
                </span>
              </div>
            </div>
          </>
        )}

        {/* 자세한 상담 */}
        {activeStep === 2 && (
          <>
            <div className={styles.titleBox}>
              <h2 className={styles.title}>자세한 상담을 원한다면?</h2>
              <p className={styles.description}>
                자세한 상담을 희망하시는 분은 아래 내용을 추가로 입력해 주시면
                <br />
                더욱 자세한 상담이 가능합니다.
              </p>
            </div>

            <div className={styles.contentBox}>
              {moreInfos.map((info) => {
                const { title, name, options } = info;
                return (
                  <div key={title}>
                    <label>{title} (택1)</label>
                    <div className={styles.radioGroups}>
                      {options.map((option) => {
                        const { label, id } = option;
                        return (
                          <div
                            key={id}
                            className={`${styles.checkBtn} ${styles.radioCheck}`}
                          >
                            <input
                              type='checkbox'
                              name={name}
                              id={id}
                              onChange={onInputChange}
                              value={id}
                              checked={moreInfo[name] === id ? true : false}
                            />
                            <label htmlFor={id}>{label}</label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}

        <div className={styles.btns}>
          <div className={styles.btn} onClick={() => setPromoOpen(false)}>
            닫기
          </div>
          <div
            className={`${styles.btn} ${styles.btn_blue} ${
              loading ? styles.disabledBtn : styles.enabledBtn
            }`}
            onClick={onSubmit}
          >
            {loading ? '전송중' : '전송하기'}
          </div>
        </div>
      </div>

      <div
        className={`${styles.alertContainer} ${
          alertPopup.open ? styles.alertShow : ''
        }`}
      >
        {alertPopup.type === 'success'
          ? '전송 완료. \n5분 이내로 가격표가 발송됩니다.'
          : alertPopup.type === 'fail'
          ? '전송 실패. \n다시 시도해 보시거나 문의해주세요.'
          : '전송 완료. 감사합니다!'}
      </div>
    </ModalPortal>
  );
};

export default PromoPopup;

function addHyphen(value) {
  if (!value) {
    return '';
  }

  value = value.replace(/[^0-9]/g, '');
  let result = [];
  let restNumber = '';

  // 지역번호와 나머지 번호로 나누기
  if (value.startsWith('02')) {
    // 서울 02 지역번호
    result.push(value.substr(0, 2));
    restNumber = value.substring(2);
  } else if (value.startsWith('1')) {
    // 지역 번호가 없는 경우
    // 1xxx-yyyy
    restNumber = value;
  } else {
    // 나머지 3자리 지역번호
    // 0xx-yyyy-zzzz
    result.push(value.substr(0, 3));
    restNumber = value.substring(3);
  }

  if (restNumber.length === 7) {
    // 7자리만 남았을 때는 xxx-yyyy
    result.push(restNumber.substring(0, 3));
    result.push(restNumber.substring(3));
  } else {
    result.push(restNumber.substring(0, 4));
    result.push(restNumber.substring(4));
  }

  return result.filter((val) => val).join('-');
}
